import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { config } from "../../config/config";
import { productTypePackage } from "../../constants/productTypes";
import { DealerProductRoute } from "../../navigation/DealerRoutes";
import { useRouteParams } from "../../navigation/useRouteParams";
import { ProductHeroBackground } from "./ProductHeroBackground";

export const ProductPageHero: FunctionComponent = () => {
  const { t } = useTranslation();
  const routeParams = useRouteParams(DealerProductRoute);
  const productType = (routeParams?.productType ?? "").toUpperCase();
  const resolvedProductType =
    productType in config.landingPageImage ? productType : productTypePackage;
  const src =
    config.landingPageImage[
      resolvedProductType as keyof typeof config.landingPageImage
    ];
  return (
    <>
      <ProductHeroBackground />
      <section
        className={clsx(
          "flex flex-col items-center mt-8 text-center px-4 z-0 select-none",
          "text-2xl md:text-3xl lg:text-4xl xl:text-5xl relative"
        )}
      >
        <h1 className="text-ink-2 text-[0.64em] md:mb-[0.2em] font-thin">
          {config.brandName}
        </h1>
        <h3 className="text-ink uppercase font-bold text-[1em]">
          {t(`hero.${resolvedProductType}`)}
        </h3>
        <img
          alt=""
          className="max-h-[12rem] lg:max-h-[16rem] my-6 md:my-8 mx-16"
          height={380}
          src={src}
        />
      </section>
    </>
  );
};

/**
 * @see docs/worklog/TW-915-accessory-landing-image/rfc.md
 * @see docs/worklog/TW-915-accessory-landing-image/tfc.md
 */
